// extracted by mini-css-extract-plugin
module.exports = {"option":"OptionSelect_option__3_STT","focado":"OptionSelect_focado__38wvJ","desabilitar":"OptionSelect_desabilitar__3el5z","novo":"OptionSelect_novo__Qdzrk"};